module.exports = "/img/_/_/_/assets/images/creeper/book/rare//10.jpg?bf50cf9b2af50393eda72b652ba254ea";